const links = [
  {
    name: "Dijkstra's algorithm",
    link: "https://en.wikipedia.org/wiki/Dijkstra%27s_algorithm",
  },
  {
    name: "DJP algorithm (Prim's algorithm) ",
    link: "https://en.wikipedia.org/wiki/Prim%27s_algorithm",
  },
  {
    name: "Dijkstra-Scholten algorithm",
    link: "https://en.wikipedia.org/wiki/Dijkstra%E2%80%93Scholten_algorithm",
  },
  {
    name: "Banker's algorithm",
    link: "https://en.wikipedia.org/wiki/Banker%27s_algorithm",
  },
  {
    name: "Dekker's algorithm (generalization)",
    link: "https://en.wikipedia.org/wiki/Dekker%27s_algorithm",
  },
  { name: "Smoothsort", link: "https://en.wikipedia.org/wiki/Smoothsort" },
  {
    name: "Shunting-yard algorithm",
    link: "https://en.wikipedia.org/wiki/Shunting-yard_algorithm",
  },
  // { name: "Tri-color marking algorithm",          link: "https://www.memorymanagement.org/glossary/t.html#:~:text=Tri%2Dcolor%20marking%20is%20a,root%20set%20is%20colored%20gray." },
  {
    name: "Concurrent algorithms",
    link: "https://en.wikipedia.org/wiki/Concurrency_(computer_science)",
  },
  {
    name: "Distributed algorithms",
    link: "https://en.wikipedia.org/wiki/Distributed_algorithm",
  },
  {
    name: "Deadlock prevention algorithms",
    link: "https://en.wikipedia.org/wiki/Deadlock_prevention_algorithms",
  },
  {
    name: "Mutual exclusion algorithms",
    link: "https://en.wikipedia.org/wiki/Mutual_exclusion",
  },
  {
    name: "Self-stabilizing algorithms",
    link: "https://en.wikipedia.org/wiki/Self-stabilization",
  },
];

export default links;
